import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageNotFoundComponent } from './page-not-found/pagenotfound.component';
import { HocModule } from '@hoc/hoc.module';
import { CoreModule } from '@core/core.module';
import { NgxTranslateModule } from '../translate/translate.module';
import { EbcontGalaxyModule } from '@ebcont/ebcont.galaxy.js';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmptyListPageComponent } from './empty-list-page/empty-list-page.component';
import { RouterLink } from '@angular/router';
import { SettingsComponent } from './settings/settings.component';
import { EmptyDetailsListPageComponent } from './empty-details-list-page/empty-details-list-page.component';
import { ListPageComponent } from './list-page/list-page.component';
import { ListItemComponent } from './list-page/list-item/list-item.component';
import { ListPlaceholderComponent } from './list-page/list-placeholder/list-placeholder.component';
import { DetailViewComponent } from './detail-view/detail-view.component';
import {TooltipComponent} from "@hoc/tooltip/tooltip.component";

@NgModule({
  declarations: [
    DashboardComponent,
    PageNotFoundComponent,
    EmptyListPageComponent,
    SettingsComponent,
    EmptyDetailsListPageComponent,
    ListPageComponent,
    ListItemComponent,
    ListPlaceholderComponent,
    DetailViewComponent
  ],
  exports: [
    DashboardComponent,
    PageNotFoundComponent,
    EmptyListPageComponent,
    EmptyDetailsListPageComponent,
    ListPageComponent,
    ListPlaceholderComponent,
    ListItemComponent,
    DetailViewComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FontAwesomeModule,
        EbcontGalaxyModule,
        HocModule,
        FormsModule,
        NgxTranslateModule,
        ReactiveFormsModule,
        RouterLink,
        CoreModule,
        TooltipComponent
    ]
})
export class GeneralModule {}
